import { composeIO } from 'react-compose-io'
import { modalPriorizarTransformacaoApiIO } from './ModalPriorizarTransformacaoApi.IO'
import ModalPriorizarTransformacaoApiView from './ModalPriorizarTransformacaoApi.View'

export const ModalPriorizarTransformacaoApi = composeIO(ModalPriorizarTransformacaoApiView, modalPriorizarTransformacaoApiIO)
